import React from "react";

/**
 * Límite de errores de React. Captura excepciones de render en el árbol de
 * componentes y muestra una pantalla de recuperación en lugar de una página en
 * blanco. Debe ser un componente de clase (no existe hook equivalente).
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary capturó un error:", error, info);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.href = "/";
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={styles.wrap}>
                    <h1 style={styles.title}>Algo salió mal</h1>
                    <p style={styles.text}>
                        Ocurrió un error inesperado. Puedes volver al inicio e intentarlo nuevamente.
                    </p>
                    <button type="button" onClick={this.handleReload} style={styles.button}>
                        Volver al inicio
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

const styles = {
    wrap: { maxWidth: 520, margin: "80px auto", textAlign: "center", fontFamily: "Arial,sans-serif", padding: 24 },
    title: { fontSize: 28, marginBottom: 12 },
    text: { color: "#666", marginBottom: 24 },
    button: {
        background: "#ef4444", color: "#fff", border: "none", borderRadius: 8,
        padding: "12px 24px", fontSize: 16, cursor: "pointer", fontWeight: "bold",
    },
};
